import { render, staticRenderFns } from "./NavbarCollapse.vue?vue&type=template&id=6a38a013&"
import script from "./NavbarCollapse.vue?vue&type=script&lang=js&"
export * from "./NavbarCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports